module.exports = __webpack_public_path__ + "img/gift_top_two.af28d6ed.png";